import script from "./FillsInQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./FillsInQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./style.scss?vue&type=style&index=0&lang=scss"
import "./FillsInQuestion.vue?vue&type=style&index=1&id=6afff710&scoped=true&lang=scss"
import "./FillsInQuestion.vue?vue&type=style&index=2&id=6afff710&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afff710"]])

export default __exports__